import { httpCreate } from './http';
import config from '@services/config';
import qs from 'qs';
const baseUrl = `${config.host}`;

const http = httpCreate('/srv/wjw-gather-user');

export const wjwGatherUser = {
	getList(gatherId, status, params) {
		return http.get(`/${gatherId}/list/${status}`, { params });
	},
	import(gatherId, body) {
		return http.post(`/import/${gatherId}`, body);
	},
	add(gatherId, body) {
		return http.post(`/add/${gatherId}`, body);
	},
	del(id) {
		return http.delete(`/del/${id}`);
	},
	getTestList(gatherId, params) {
		return http.get(`/${gatherId}/testUserList`, { params });
	},
	getTestDetail(gatherId, userId) {
		return http.get(`/${gatherId}/testInfo/${userId}`);
	},
	getUserStudyDetail(gatherId, userId) {
		return http.get(`/${gatherId}/classLearning/${userId}`);
	},
	export(gatherId, status, params) {
		return `${baseUrl}/excel/live/wjw-gather-user/${gatherId}/list/${status}?${qs.stringify(params)}`;
	},
};
